import React from "react";

export const WithBaseStyles = (Component, { baseStyle, defaultProps, variants }) => React.memo(
    React.forwardRef(
        (props, ref) => {
            const variantObject = React.useMemo(() => variants?.[props.variant], [props.variant])

            const propsOrDefaultProps = !defaultProps ? {} : Object.keys(defaultProps).map((key) => props[key] !== undefined ? props[key] : defaultProps[key]);
            const style= React.useMemo(() => [propsOrDefaultProps.style, variantObject, props.style], [propsOrDefaultProps.style, props.style]);

            return <Component {...baseStyle} { ...variantObject } {...defaultProps} ref={ref} {...props} {...propsOrDefaultProps} style={style} />
        }
    )
)